import type { JSX } from 'react';

/**
 * Small line drawings for the schedule's toolbar, in the text colour and the
 * size of an icon button - drawn here rather than from an icon set, so no
 * other product's symbols are copied and nothing extra is loaded.
 */
const frame = { width: 16, height: 16, viewBox: '0 0 16 16', fill: 'none', stroke: 'currentColor', strokeWidth: 1.4, strokeLinejoin: 'round' as const, 'aria-hidden': true };

/** List and chart side by side. */
export function SideBySideIcon(): JSX.Element {
  return <svg {...frame}><rect x="1.5" y="2.5" width="13" height="11" rx="1.5" /><line x1="6.5" y1="2.5" x2="6.5" y2="13.5" /></svg>;
}

/** List above the chart. */
export function StackedIcon(): JSX.Element {
  return <svg {...frame}><rect x="1.5" y="2.5" width="13" height="11" rx="1.5" /><line x1="1.5" y1="7" x2="14.5" y2="7" /></svg>;
}

/** Choosing the columns of the list. */
export function ColumnsIcon(): JSX.Element {
  return <svg {...frame}><rect x="1.5" y="2.5" width="13" height="11" rx="1.5" /><line x1="5.5" y1="2.5" x2="5.5" y2="13.5" /><line x1="10.5" y1="2.5" x2="10.5" y2="13.5" /></svg>;
}
